import { render, staticRenderFns } from "./ProductSetSlider.vue?vue&type=template&id=b43ba254&scoped=true&"
import script from "./ProductSetSlider.vue?vue&type=script&lang=js&"
export * from "./ProductSetSlider.vue?vue&type=script&lang=js&"
import style0 from "./ProductSetSlider.vue?vue&type=style&index=0&id=b43ba254&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43ba254",
  null
  
)

export default component.exports